/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { Admin, Appliance, Cabinet, DummyDoNotUse, Part, Preset, PresetCategory, Recipe } from './admin-model/index.js';
export const constants = {};
const PresetCategoryExpressions = [
    '$isDraft',
    '$admin',
    '$presets'
];
const AdminExpressions = [
    '$pricingItems',
    '$cabinets',
    '$parts',
    '$appliances',
    '$presets',
    '$presetCategories',
    '$recipes'
];
const PresetExpressions = [
    '$admin',
    '$category',
    '$violations'
];
const RecipeExpressions = [
    '$admin'
];
export const $Admin = new $DomainEntityReflection('Admin', [
    ...AdminExpressions
]);
export const $Preset = new $DomainEntityReflection('Preset', [
    ...PresetExpressions
]);
export const $PresetCategory = new $DomainEntityReflection('PresetCategory', [
    ...PresetCategoryExpressions
]);
export const $Recipe = new $DomainEntityReflection('Recipe', [
    ...RecipeExpressions
]);
export const $DummyDoNotUse = new $DomainEntityReflection('DummyDoNotUse', []);
export const $Cabinet = new $DomainEntityReflection('Cabinet', []);
export const $Appliance = new $DomainEntityReflection('Appliance', []);
export const $Part = new $DomainEntityReflection('Part', []);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type,
    DummyDoNotUse.type,
    Cabinet.type,
    Appliance.type,
    Part.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Admin.type
]);
export const $CommonAdminEntity = new EnhancedAliasReflection('$CommonAdminEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type
]);
export const $PricingItem = new EnhancedAliasReflection('$PricingItem', [
    Appliance.type,
    Cabinet.type,
    Part.type
]);
export const $entityReflections = {
    Admin: $Admin,
    Preset: $Preset,
    PresetCategory: $PresetCategory,
    Recipe: $Recipe,
    DummyDoNotUse: $DummyDoNotUse,
    Cabinet: $Cabinet,
    Appliance: $Appliance,
    Part: $Part
};

//# sourceMappingURL=admin-enhanced-model.js.map